
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { axios } from '@/plugins/axios'
import { useStore } from '@/store/index'
import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import AccountInfo from '@/components/AccountInfo.vue'
import { useRouter } from 'vue-router'
import { ALERT_COLORS } from '@/store/base'

export default defineComponent({
  components: { LayoutsAuth, AccountInfo, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const router = useRouter()

    const onLogout = () => {
      axios
        .get('/logout')
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('logout.success')], persistent: true, color: ALERT_COLORS.info })
          router.push('/login')
        })
    }

    return {
      store,
      onLogout
    }
  },
})
